var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('el-breadcrumb',{staticClass:"pc-breadcrumb",attrs:{"separator":"/"}},_vm._l((_vm.data),function(item){return _c('el-breadcrumb-item',{key:item.name},[_c('router-link',{attrs:{"to":item.link}},[_vm._v("\n      "+_vm._s(item.name)+"\n    ")])],1)}),1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-631894e8","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/template/BreadCrumb.vue
// module id = ZhTi
// module chunks = 0